import { render, staticRenderFns } from "./WorkUploader.vue?vue&type=template&id=5cafc579&scoped=true"
import script from "./WorkUploader.vue?vue&type=script&lang=js"
export * from "./WorkUploader.vue?vue&type=script&lang=js"
import style0 from "./WorkUploader.vue?vue&type=style&index=0&id=5cafc579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cafc579",
  null
  
)

export default component.exports